/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortHistoryNameGet200ResponseRecordsInner } from './PortHistoryNameGet200ResponseRecordsInner';
import {
    PortHistoryNameGet200ResponseRecordsInnerFromJSON,
    PortHistoryNameGet200ResponseRecordsInnerFromJSONTyped,
    PortHistoryNameGet200ResponseRecordsInnerToJSON,
} from './PortHistoryNameGet200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface PortHistoryNameGet200Response
 */
export interface PortHistoryNameGet200Response {
    /**
     * 
     * @type {Array<PortHistoryNameGet200ResponseRecordsInner>}
     * @memberof PortHistoryNameGet200Response
     */
    records?: Array<PortHistoryNameGet200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the PortHistoryNameGet200Response interface.
 */
export function instanceOfPortHistoryNameGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortHistoryNameGet200ResponseFromJSON(json: any): PortHistoryNameGet200Response {
    return PortHistoryNameGet200ResponseFromJSONTyped(json, false);
}

export function PortHistoryNameGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortHistoryNameGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(PortHistoryNameGet200ResponseRecordsInnerFromJSON)),
    };
}

export function PortHistoryNameGet200ResponseToJSON(value?: PortHistoryNameGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(PortHistoryNameGet200ResponseRecordsInnerToJSON)),
    };
}

